import React from 'react';
import { sponsors } from '../mock';
import { Button } from './ui/button';

const Sponsors = () => {
  return (
    <section className="sponsors-section" id="sponsors">
      <div className="container">
        <h2 className="section-title-center">Our Amazing Partners</h2>
        <p className="section-subtitle-center">
          These incredible organizations help us inspire and empower the next generation of leaders and creators.
        </p>
        
        <div className="sponsors-grid">
          {sponsors.map((sponsor) => (
            <a
              key={sponsor.id}
              href={sponsor.website}
              target="_blank"
              rel="noopener noreferrer"
              className="sponsor-card"
            >
              <img 
                src={sponsor.logo} 
                alt={sponsor.name}
                className="sponsor-logo"
              />
            </a>
          ))}
        </div>
        
        <div className="text-center" style={{ marginTop: '60px' }}>
          <Button 
            className="btn-donate"
            onClick={() => window.open('https://www.paypal.com/donate/?hosted_button_id=AEHEL7SM4U2V6', '_blank')}
          >
            <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>
            Donate To Future Episodes
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Sponsors;